import './App.scss';
import { Banner } from 'components/banner/Banner';
import { Header } from 'components/header/Header';
import { Card } from 'components/Card/Card';
import { Footer } from 'components/footer/Footer';
import { homeCardList } from 'helper/data/home';


function App() {
  return (
    <>
    <Header />
    <div className="App">
     <Banner />
     <div className='container'>
     <div className='vision-top-text'>
      <h1 className="vision-heading"><strong>Private Gallery</strong></h1>
      <p className="vision-description">
      Private Gallery is a powerful virtual space application designed to provide file protection for users. With Private Gallery , you can protect photos, videos and other files that you don't want others to view on your phone. If you need to check the card, you must enter the password again.</p>
     </div>
      {homeCardList.map((card, i) => (
        <Card isImgLeft={(i+1) % 2 === 0} key={card.desc} title={card.title} des={card.desc} img={card.img} />
      ))}
     </div>
     <div className='container privacy-frame'>
       <div className='privacy-img-frame'>
        <img src={require("assets/img/privacy_artwork_icon2x.png")} alt="" />
        <div className='privacy-bg'></div>
       </div>
       <div className='privacy-des-frame'>
         <h1 className="title"><strong>Privacy is central to everything we do. </strong></h1>
         <p className="text-alignment---center">At Private Gallery, privacy is one of our core values. Every product we create is designed to safeguard your data. In today’s complex world, we strongly believe that your data belongs to you alone. We take our responsibility to protect your information, and your trust in us, very seriously.<br/><br/>
            <a href="https://sites.google.com/view/superprivategallery/home/privacy-policy" target="_blank" className="link" rel="noreferrer">Privacy Policy</a>
          </p>
       </div>
     </div>
     <div className='container world-map'>
       <div className='word-map-text-frame'>
       <h2><strong>Available<br />Everywhere</strong></h2>
          <p className="description">No matter what device you’re on – we’ve got you covered! Private Gallery  is your perfect file manager to help you protect private files. </p>
       </div>
       <div className='map-img'></div>
     </div>
    </div>
    <Footer />
    </>
  );
}

export default App;
